import React from 'react'
import { Link } from 'react-router-dom'
function Footer() {
  return (
    <footer className=" border-top bg-dark text-light mt-4">
    <div className="container">
      <div className="row pt-5">
        <div className="col-lg-4 text-start">
        <a className="navbar-brand" href="#"><img src={require('../image/logo.jpg')}/></a>
          <p className='py-4 text-secondary fw-semibold'>News24 is a Clean Responsive HTML News-paper, Magazine, News and Blog template. with good feature that allow you to completely customize your website to your needs.</p>
        </div>
        <div className="col-lg-4 text-start">
        <h2 className="me-2 fw-bold"><span className="a">MOST VIWED</span></h2>
        <h5 className='text-light fw-bold pt-3 fs-5'>Oct 28, 2016</h5>
          <a href='/'><p className='text-secondary text-decoration-underline fw-bold fs-5'>Success is not a good teacher failure makes you humble</p></a>
          <h5 className='text-light fw-bold pt-3 fs-5'>Oct 28, 2016</h5>
          <a href='/'><p className='text-secondary text-decoration-underline fw-bold fs-5'>Success is not a good teacher failure makes you humble</p></a>
        </div>
        <div className="col-lg-4 text-start footsub">
        <h2 className="me-2 fw-bold"><span className="a">MOST VIWED</span></h2>
         <div className='d-flex mt-4'>
         <button type="button" class="btn btn-outline-light"><Link to="/world" className='text-light'>Worlds</Link></button>
         <button type="button" class="btn btn-outline-light mx-2">Entertainment</button>
         <button type="button" class="btn btn-outline-light">Health</button>
         </div>
         <div className='d-flex mt-2'>
         <button type="button" class="btn">Football</button>
         <button type="button" class="btn mx-2">News</button>
         <button type="button" class="btn">Fasion</button>
         <button type="button" class="btn ms-2">Health</button>
         </div>
         <div className='d-flex mt-2'>
         <button type="button" class="btn">Western Foods</button>
         <button type="button" class="btn ms-2">Western Foods</button>
         </div>
         <div className='d-flex mt-2'>
         <button type="button" class="btn btn-outline-light">Race</button>
         <button type="button" class="btn btn-outline-light mx-2">Football</button>
         <button type="button" class="btn btn-outline-light">Foods</button>
         </div>
        </div>
      </div> 
    </div>
     <hr/> 
    <section className="pt-4">
      <div className="container">
          <div className='row'>
              <div className='col-lg-6 text-sm-center text-lg-start'>
              <p className='text-secondary'>© 2020 All Rights Reserved by Bestwebcreator</p> 
              </div>
              <div className='col-lg-6'>
              <ul className='pb-3 ps-0 lh-lg text-light new d-flex float-end'>
         <li className='pb-2 fw-normal'><a href='/'><i class="bi bi-facebook"></i></a></li>
         <li className='pb-2 fw-normal'><a href='/'><i class="bi bi-twitter"></i></a></li>
         <li className='pb-2 fw-normal'><a href='/'><i class="bi bi-google"></i></a></li>
         <li className='pb-2 fw-normal'><a href='/'><i class="bi bi-pinterest"></i></a></li>
         <li className='pb-2 fw-normal'><a href='/'><i class="bi bi-instagram"></i></a></li>  
         </ul>
              </div>
          </div> 
      </div>
    </section>  
  </footer>
  )
}

export default Footer
